import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore from './redux/store';
import App from './App';
import './index.css';
import './App.css';
import './common.css';
import { HelmetProvider } from 'react-helmet-async';

const shouldEnableSentry = () => {
  if (import.meta.env.VITE_APP_ENABLE_SENTRY === 'true') {
    return true;
  }

  if (
    import.meta.env.VITE_APP_STAGE !== 'production' ||
    import.meta.env.SSR ||
    window.location.hostname.includes('local')
  ) {
    return false;
  }

  return true;
};

Sentry.init({
  dsn: 'https://256db101f631477ca864737ef443825c@glitch.azure-services.myyogateacher.com/1',
  // integrations: [
  //   Sentry.captureConsoleIntegration({
  //     levels: ['error']
  //   })
  // ],
  environment: import.meta.env.VITE_APP_STAGE,
  autoSessionTracking: false,
  enabled: shouldEnableSentry()
});

const store = configureStore();

export default class NewApp extends React.Component {
  componentDidMount() {
    if (navigator.serviceWorker) {
      try {
        navigator.serviceWorker.addEventListener('message', (event) => {
          const { type, role, channelUuid } = event.data || {};
          if (type !== 'CHAT_CLICK' && !channelUuid) return;
          sessionStorage.setItem(
            'pendingChatOpen',
            JSON.stringify({ role, channelUuid, ts: Date.now() })
          );
          const redirectUrl = role === 'teacher' ? '/teacher_chat' : '/student_chat';
          if (!window.location.pathname.startsWith(redirectUrl)) {
            const qp = channelUuid
              ? `?from=push&channel=${encodeURIComponent(channelUuid)}`
              : '?from=push';
            window.location.assign(`${redirectUrl}${qp}`);
          } else {
            // Already on chat page? Dispatch a DOM event so the page can react immediately
            window.dispatchEvent(new CustomEvent('chat:open', { detail: { channelUuid } }));
          }
        });
      } catch (error) {
        console.log('Error in navigator block in main', error);
      }
    }
  }

  render() {
    return (
      <Sentry.ErrorBoundary fallback={<div>Loading</div>}>
        <HelmetProvider>
          <Provider store={store}>
            <App />
          </Provider>
        </HelmetProvider>
      </Sentry.ErrorBoundary>
    );
  }
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<NewApp />);
